import { createSelector } from 'reselect';

export const getConfiguration = state => state.configuration;

export const getApplicationName = createSelector(
  [getConfiguration],
  configuration => _.get(configuration, 'applicationName'),
);




// WEBPACK FOOTER //
// ./src/shared/selectors/configuration.js